<template>
  <el-dialog class="registe-dialog"
             :visible.sync="visible"
             :title="$t('registe.changeuser')"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             width="1100px">
    <div class="mod-joylearning__registeinfo_user">
      <el-form
        label-width="auto"
        label-position="left"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <div class="top_message">
        <!-- 排期信息显示 -->
          <el-row>
            <el-col :span="6">
              <!-- 排期编号 -->
              <el-form-item :label="$t('registe.offeringcode')"
                          prop="offeringNo">
                <el-input v-model="dataofferinginfo.offeringNo"
                :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 课程代码 -->
              <el-form-item :label="$t('couse.coursecode')"
                          prop="courseCode">
                <el-input v-model="dataofferinginfo.courseCode"
                :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 课程名称 -->
              <el-form-item :label="$t('registe.coursename')"
                          prop="courseNameCn">
                <el-input v-model="dataofferinginfo.courseNameCn"
                :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 培训师 -->
              <el-form-item :label="$t('registe.trainer')"
                          prop="trainerName">
                <el-input v-model="dataofferinginfo.trainerName"
                 :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <!-- 排期名称 -->
              <el-form-item :label="$t('registe.offeringname')"
                          prop="offeringName">
                <el-input v-model="dataofferinginfo.offeringName"
                 :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 场地 -->
              <el-form-item :label="$t('registe.place1')"
                          prop="roomName">
                <el-input v-model="dataofferinginfo.roomName"
                 :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 开始时间 -->
              <el-form-item :label="$t('registe.startdate')"
                          prop="startdate">
                <el-input v-model="dataofferinginfo.startdate"
                 :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 结束时间 -->
              <el-form-item :label="$t('registe.enddate')"
                          prop="enddate">
                <el-input v-model="dataofferinginfo.enddate"
                 :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row class="margb10">
          <el-col :span="7">
            <!-- 姓名 -->
            <el-form-item :label="$t('registe.username')">
              <el-input v-model="dataForm.userName"
                        :placeholder="$t('registe.input')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <!-- 岗位 -->
            <el-form-item :label="$t('registe.positionname')">
              <el-input v-model="dataForm.positionName"
                        :placeholder="$t('registe.input')"></el-input>
            </el-form-item>
          </el-col>
          <div class="left-search">
            <!-- 查询 -->
            <el-col :span="3" style="float: left;margin-left: 50px">
              <el-button class="M-search"
                        type="primary"
                        @click="getDataListMerge">{{$t('user.query')}}</el-button>
            </el-col>
            <!-- 重置 -->
            <el-col :span="3" style="float: right;margin-right: 50px">
              <el-button class="el-back M-search M-margin-l"
                        type="info"
                        @click="again">{{$t('reset')}}</el-button>
            </el-col>
          </div>
        </el-row>
      </el-form>
      <div class="table-user table">
        <el-table :data="dataList"
                  border
                  v-loading="dataListLoading"
                  @selection-change="userListChange"
                  style="width: 100%">
          <!-- 选择框 -->
          <el-table-column type="selection" header-align="center"
                         align="center"
                           width="30">
          </el-table-column>
          <!-- NO. -->
          <el-table-column prop="userId"
                           :label="$t('registe.no')"
                           width="150"
                           align="center">
          </el-table-column>
          <!-- 姓名 -->
          <el-table-column prop="userNameCn"
                           :label="$t('registe.username')"
                           width="150"
                           align="center">
          </el-table-column>
          <!-- 岗位 -->
          <el-table-column prop="positionNameCn"
                           :label="$t('registe.positionname')"
                           width="150"
                           align="center">
          </el-table-column>
          <!-- 经销商 -->
          <el-table-column prop="nameCn"
                           :label="$t('registe.orgname')"
                           align="center">
          </el-table-column>

        </el-table>
      </div>
      <div class="block"
           style="float: right;margin-top: 10px; margin-bottom: 10px">
        <el-pagination @size-change="pageSizeChangeHandle"
                       @current-change="pageCurrentChangeHandle"
                       :current-page="page"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="limit"
                       layout="total, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
    </div>
    <template slot="footer">
      <div class="dialog-footer">
        <el-button @click="visible = false">{{ $t('registe.change') }}</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      // 获取列表信息
      mixinViewModuleOptions: {
        getDataListURL: '/learning/offeringregiste/pageUser',
        getDataListIsPage: true
      },
      registeId: '',
      visible: false,
      dataForm: {
        userName: '', // 姓名
        positionName: '' // 岗位
      },
      dataofferinginfo: {
        offeringNo: '', // 排期编号
        courseCode: '', // 课程代码
        courseNameCn: '', // 课程名称
        offeringName: '', // 派其名称
        trainerName: '', // 培训师
        roomName: '', // 场地
        startdate: '', // 开始时间
        enddate: '' // 结束时间
      },
      // 列表list
      dataList: [],
      // 等待转圈
      dataListLoading: false
    }
  },
  computed: {
  },
  created () {
    this.mixinViewModuleOptions.getDataListURL =
      '/learning/offeringregiste/pageUser'
    this.mixinViewModuleOptions.getDataListIsPage = true
    this.getDataList()
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.getOfferingInfo(this.registeId)
      })
    },
    // 查询
    getDataListMerge () {
      this.getDataList()
    },
    // 重置
    again () {
      this.dataForm = {
        userName: '', // 姓名
        positionName: '' // 岗位
      }
      this.getDataList()
    },
    // 排期信息的回显
    getOfferingInfo (registeId) {
      this.dataofferinginfo = {}
      this.$request.get('/learning/offeringregiste/getOfferingInfo/' + registeId).then((res, total, code, data) => {
        this.dataofferinginfo = data.data
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 10px;
  padding-bottom: 20px !important;
}
</style>
